import * as React from 'react';
import AnimatableDiv from 'shared/symbols/AnimatableDiv';
import { mouseEventProps } from '../mouseEventProps';
import { joinClass } from '../symbolUtils';
import { calcClasses, calcTextStyles } from './calcUtils';
import { useTextScale } from './useTextScale';
export const textAttributeStyleMap = {
    horizontalAlignment: {
        left: { textAlign: 'left' },
        center: { textAlign: 'center' },
        right: { textAlign: 'right' },
        justify: { textAlign: 'justify' },
    },
    verticalAlignment: {
        top: { alignItems: 'flex-start' },
        center: { alignItems: 'center' },
        bottom: { alignItems: 'flex-end' },
    },
};
const Text = (props) => {
    var _a;
    const { conditionalState, hoverAnimation, symbol, timelineRefId, innerRef, inEditor, } = props;
    const internalRef = React.useRef(null);
    const containerRef = innerRef || internalRef;
    const [scale] = useTextScale(containerRef, props);
    const { clickClass, onClick } = mouseEventProps(symbol, inEditor, hoverAnimation);
    const { attributes, position } = conditionalState;
    const content = attributes ? attributes.content : '';
    const textClass = calcClasses(props, scale);
    const className = joinClass(textClass, clickClass);
    const { containerStyles, textStyles } = calcTextStyles(props, scale);
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: containerRef, inEditor: inEditor, onClick: onClick, style: containerStyles, position: position },
        React.createElement("div", { 
            // repaint and apply WebkitBackgroudClip when value change
            key: (_a = textStyles) === null || _a === void 0 ? void 0 : _a.background, style: Object.assign({ boxSizing: 'border-box', cursor: 'inherit', width: '100%' }, textStyles), dangerouslySetInnerHTML: { __html: textFillColor(content) } })));
};
export default Text;
/**
 * Add additional `webkitTextFillColor` attribute to span with color
 * Ensure inner span shows color consistently across browsers
 *
 * Note: `webkitTextFillColor` is supported in all modern browsers
 * even though it has `webkit` prefix, and more stable than `textFillColor` as of 2023
 */
const textFillColor = (content) => {
    const html = document.createElement('div');
    html.innerHTML = content;
    Array.from(html.querySelectorAll('span')).forEach(span => {
        const color = span.style.color;
        if (color) {
            span.style.webkitTextFillColor = color;
        }
    });
    return html.innerHTML;
};
